import { useTranslation } from 'react-i18next';

const reasonsData = [
  {
    icon: 'ri-map-pin-2-line',
    titleKey: 'about_why_1_title',
    descKey: 'about_why_1_desc',
    image: 'https://readdy.ai/api/search-image?query=Authentic%20Colombian%20street%20food%20close%20up%20vibrant%20colorful%20traditional%20ingredients%20spices%20herbs%20dark%20moody%20background%20orange%20accent%20lighting%20food%20photography&width=600&height=400&seq=why1&orientation=landscape',
  },
  {
    icon: 'ri-leaf-line',
    titleKey: 'about_why_2_title',
    descKey: 'about_why_2_desc',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20premium%20burger%20ingredients%20laid%20out%20flat%20lay%20avocado%20tomato%20lettuce%20cheese%20beef%20patty%20dark%20slate%20background%20orange%20accent%20food%20styling%20professional%20photography&width=600&height=400&seq=why2&orientation=landscape',
  },
  {
    icon: 'ri-heart-line',
    titleKey: 'about_why_3_title',
    descKey: 'about_why_3_desc',
    image: 'https://readdy.ai/api/search-image?query=Friendly%20food%20truck%20staff%20handing%20over%20food%20bag%20smiling%20warm%20interaction%20urban%20street%20setting%20dark%20moody%20lighting%20orange%20glow%20Latin%20American%20vibe&width=600&height=400&seq=why3&orientation=landscape',
  },
  {
    icon: 'ri-truck-line',
    titleKey: 'about_why_4_title',
    descKey: 'about_why_4_desc',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20urban%20food%20truck%20at%20night%20with%20bold%20orange%20branding%20neon%20lights%20dark%20street%20atmosphere%20Latin%20American%20identity%20modern%20design%20cinematic%20photography&width=600&height=400&seq=why4&orientation=landscape',
  },
];

export default function WhyBucara() {
  const { t } = useTranslation();

  return (
    <section className="bg-[#0A0A0A] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-10 h-0.5 bg-[#F57F25]"></div>
            <span className="text-[#F57F25] text-xs font-bold tracking-widest uppercase">{t('about_why_eyebrow')}</span>
            <div className="w-10 h-0.5 bg-[#F57F25]"></div>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-white uppercase leading-tight">
            {t('about_why_title')} <span className="text-[#F57F25]">{t('about_why_title_accent')}</span>
          </h2>
          <p className="text-white/50 text-base mt-4 max-w-xl mx-auto">
            {t('about_why_sub')}
          </p>
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {reasonsData.map((r, i) => (
            <div
              key={i}
              className="group relative rounded-2xl overflow-hidden border border-white/10 hover:border-[#F57F25]/40 transition-all duration-300"
            >
              {/* Background image */}
              <div className="absolute inset-0">
                <img
                  src={r.image}
                  alt={t(r.titleKey)}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/70 to-black/30"></div>
              </div>

              {/* Content */}
              <div className="relative z-10 p-8 min-h-[280px] flex flex-col justify-end">
                {/* Icon */}
                <div className="w-12 h-12 flex items-center justify-center bg-[#F57F25]/20 border border-[#F57F25]/40 rounded-xl mb-4">
                  <i className={`${r.icon} text-[#F57F25] text-xl`}></i>
                </div>
                <h3 className="text-white text-xl font-black uppercase mb-3 leading-tight">{t(r.titleKey)}</h3>
                <p className="text-white/60 text-sm leading-relaxed">{t(r.descKey)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
